function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M2 4.603C2 3.717 2.716 3 3.6 3h12.8c.884 0 1.6.717 1.6 1.603v8.012c0 .885-.716 1.603-1.6 1.603H9.34a.4.4 0 00-.25.088l-3.24 2.596a.4.4 0 01-.65-.313v-1.97a.4.4 0 00-.4-.401H3.6c-.884 0-1.6-.718-1.6-1.603V4.603z",
  fill: "#fff"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.428 18.326c-.268.187-.449.502-.344.812a1.6 1.6 0 001.516 1.09h7.06a.4.4 0 01.25.087l3.24 2.596a.4.4 0 00.65-.312v-1.971a.4.4 0 01.4-.4h1.2c.884 0 1.6-.718 1.6-1.603v-8.013c0-.885-.716-1.603-1.6-1.603H20a.5.5 0 00-.5.501v3.105a3.102 3.102 0 01-3.1 3.105h-5.972c-.454 0-.895.155-1.25.439l-2.391 1.916-.359.25z",
  fill: "#fff"
});

var SvgChats = function SvgChats(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _ref, _ref2);
};

export default SvgChats;